<template>
    <div class="storeData">
        <div class="storeData_nap">
            <el-date-picker
                v-model="dateDay"
                value-format="yyyy-MM-dd"
                type="daterange"
                @change="dateRangeChange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期">
            </el-date-picker>
        </div>
        <div class="storeData_pane">
            <div style="width: 1200px">
                <div
                    class="my-charts"
                    ref="myChart"
                    id="myChart"
                    :style="{ width: chartsWidth, height: '600px' }"
                ></div>
            </div>
        </div>
    </div>
</template>
<script>
    import {analyseLoginLog} from "../../utils/interface";

    export default {
        name: "loginLogAnalyse",
        components: {
        },
        data() {
            return {
                tabPosition: "",
                dateDay: [],
                chartsWidth: "",
                startTime: "",
                endTime: "",
                loading: false,
                logList:[],
            };
        },
        created() {
            this.chartsWidth = window.innerWidth - 220 + "px";
        },
        mounted() {
            this.currentTime();
            this.nextTime();
            this.init();
        },
        methods: {
            init(){
                this.dateDay.push(new Date(this.startTime));
                this.dateDay.push(new Date(this.endTime));
                this.getList();
            },
            dateRangeChange(date) {
                this.startTime = date[0];
                this.endTime = date[1];
                this.getList();
            },
            nextTime () {
                let end = new Date()
                end = this.formatDate(end, 'yyyy-MM-dd')
                end = this.getUpMonth(end)
                return end
            },
            currentTime () {
                let start = new Date()
                this.endTime = this.formatDate(start, 'yyyy-MM-dd')
            },
            formatDate (date, fmt = 'yyyy-MM-dd hh:mm:ss') {
                date = new Date(date)
                if (/(y+)/.test(fmt)) {
                    fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length))
                }
                let o = {
                    'M+': date.getMonth() + 1,
                    'd+': date.getDate(),
                    'h+': date.getHours(),
                    'm+': date.getMinutes(),
                    's+': date.getSeconds()
                }
                for (let k in o) {
                    if (new RegExp(`(${k})`).test(fmt)) {
                        let str = o[k] + ''
                        fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? str : '0'+str)
                    }
                }
                return fmt
            },
            getUpMonth (data) {
                let arr = data.split('-')
                let year = arr[0] // 获取当前日期的年份
                let month = arr[1] // 获取当前日期的月份
                let day = arr[2] // 获取当前日期的日
                let year2 = year
                let month2 = parseInt(month) - 1
                if (month2 === 13) {
                    year2 = parseInt(year2) + 1
                    month2 = 1
                }
                let day2 = day;
                let days2 = new Date(year2, month2, 0)
                days2 = days2.getDate()
                if (day2 > days2) {
                    day2 = days2
                }
                if (month2 < 10) {
                    month2 = '0' + month2
                }
                this.startTime = year2 + '-' + month2 + '-' + day2;
            },
            getList(){
                this.loading = true
                let data = {
                    startTime:this.startTime,
                    endTime:this.endTime
                }
                console.log(data)
                analyseLoginLog(data).then((res)=>{
                    if(res.success){
                        this.logList = res.data;
                        let xData= [];
                        let yData=[];
                        for(let key in res.data){ //此处遍历map
                            console.log(1+"---"+key)
                            xData.push(key);
                            yData.push(res.data[key]);
                        }
                        this.drawLine(xData,yData);
                    }else {
                        this.$message.error(res.message)
                    }
                    this.loading = false
                });
            },
            drawLine(xData,y1Data) {
                // 基于准备好的dom，初始化echarts实例
                let myChart = this.$echarts.init(this.$refs.myChart);
                // 绘制图表
                myChart.setOption({
                    // title: {
                    //   text: "当周批转量和报备量",
                    //   left: "5%",
                    // },
                    tooltip: { trigger: "axis" },
                    legend: {
                        data: ["登录人次"],
                        right: "5%",
                    },
                    grid: {
                        left: "5%",
                        right: "6%",
                        bottom: "10%",
                        containLabel: true,
                    },
                    xAxis: {
                        type: "category",
                        boundaryGap: false,
                        data: xData,
                        axisLine: {
                            lineStyle: {
                                color: "#999",
                                width: 0.1
                            },
                        },
                        splitLine: {
                            show: true,
                            lineStyle: {
                                color: "#999",
                                width: 0.1,
                            },
                        },
                    },
                    yAxis: {
                        type: "value",
                        axisLine: {
                            lineStyle: {
                                color: "#999",
                                width: 0.1
                            },
                        },
                    },
                    series: [
                        {
                            name: "登录人次",
                            type: "line",
                            data: y1Data,
                            smooth: true,
                            itemStyle: {
                                normal: {
                                    color: "#53e59d",
                                },
                            },
                        },
                    ],
                });
            },
        },
    };
</script>
<style scoped lang="less">
    .storeData {
        padding: 20px;
        background: #fff;
        margin: 0 20px;

        .storeData_nap {
            display: flex;
            align-items: center;
            justify-content: space-between;
            font-size: 14px;
        }
    }

    //隐藏的CSS代码
    /*按钮日期选择器隐藏ipnut*/
    .hide_input {
        position: relative !important;
    }

    //修改控件自带的css
    .hide_input /deep/ .el-date-editor {
        position: absolute; //绝对定位
        top: 0;
        left: 0;
        opacity: 0; //设置完全透明
    }

    .hide_input /deep/ .el-input__prefix {
        left: 0;
        width: 55px;
    }
</style>



// WEBPACK FOOTER //
// src/views/logManage/loginLogAnalyse.vue